import { UPDATE_T_AND_C } from "../../Legal/sections/terms-and-conditions/constants"

export default (tcManager) => ({
  tcManager,
  type: UPDATE_T_AND_C,
})
